import React, { useState, useEffect, useRef } from "react";
import Header from "../Header";
import Footer from "../Footer";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import { fetchReceivedPaymentcollectionList } from "../../services/AccountServices";
import config from "../common/Config";
import * as XLSX from "xlsx";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import Select from "react-select";
import CommonDatePicker from "../datepicker/CommonDatePicker";
import "rsuite/dist/rsuite.min.css";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { setTableWidths, getTableWidths } from "../../data/postAPi";

const PaymentProcess = () => {
  const [reportrange, setReportrange] = useState("");
  const [dates, setDates] = useState([new Date(), new Date()]);
  const [draw] = useState(1);
  const [start] = useState(0);
  const [length] = useState(5000);
  const accessToken = localStorage.getItem("accessToken");

  const [receivedPayment, setReceivedPayment] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [shouldLoadPayments, setShouldLoadPayments] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [customerFilter, setCustomerFilter] = useState("");
  const [customerOptions, setCustomerOptions] = useState([]);
  const [customerInputValue, setCustomerInputValue] = useState(null);
  const [salesrepOptions, setSalesrepOptions] = useState([]);
  const [salesrepInputValue, setSalesrepInputValue] = useState(null);
  const [shopDetails, setShopDetails] = useState(null);
  const [logoBase64, setLogoBase64] = useState(null);
  const [colWidths, setColWidths] = useState([60, 300, 100, 100, 100, 100]);
  const userId = localStorage.getItem("userId");
  const tableName = "paymentCollectionTable";
  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
  const debouncedSetTableWidths = useRef(
    debounce((userId, tableName, widths) => {
      setTableWidths(userId, tableName, widths);
    }, 500)
  ).current;
  const tableRef = useRef(null);

  const startResizing = (index, e) => {
    e.preventDefault();
    const startX = e.clientX;
    const startWidth = colWidths[index];
    const onMouseMove = (moveEvent) => {
      const newWidth = Math.max(50, startWidth + moveEvent.clientX - startX);
      setColWidths((widths) => {
        const updated = [...widths];
        updated[index] = newWidth;
        debouncedSetTableWidths(userId, tableName, updated);
        return updated;
      });
    };
    const onMouseUp = () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  };

  const searchFormData = () => {
    const startDate = dates[0] ? format(dates[0], "MM/dd/yyyy") : "";
    const endDate = dates[1] ? format(dates[1], "MM/dd/yyyy") : "";
    setReportrange(startDate ? `${startDate} - ${endDate}` : "");
    setShouldLoadPayments(true);
  };

  useEffect(() => {
    if (!accessToken) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }
    if (isInitialLoad) {
      loadReceivedPaymentList();
      setIsInitialLoad(false);
    } else if (shouldLoadPayments) {
      loadReceivedPaymentList();
      setShouldLoadPayments(false);
    }
  }, [shouldLoadPayments, accessToken, isInitialLoad]);

  const loadReceivedPaymentList = async () => {
    try {
      const customer = customerInputValue ? customerInputValue.value : "";
      const salesrep = salesrepInputValue ? salesrepInputValue.value : "";
      const data = await fetchReceivedPaymentcollectionList(
        draw,
        start,
        length,
        reportrange,
        accessToken,
        customer,
        salesrep
      );
      setReceivedPayment(data.data || []);
      setFilteredData(data.data || []);
      setShopDetails(data.shop_details || null);
    } catch (error) {
      console.error("Failed to load received payment list:", error);
    }
  };

  useEffect(() => {
    (async function fetchWidths() {
      try {
        const res = await getTableWidths(userId, tableName);
        if (res?.data?.widths && Array.isArray(res.data.widths) && res.data.widths.length > 0) {
          setColWidths(res.data.widths);
        } else {
          setColWidths([60, 300, 100, 100, 100, 100, 100]);
        }
      } catch (e) {
        setColWidths([60, 300, 100, 100, 100, 100, 100]);
      }
    })();
  }, []);

  useEffect(() => {
    const table = $("#PaymentCollection").DataTable({
      // destroy: true,
      data: filteredData,
      autoWidth: false,
      columns: [
        { data: "date" },
        { data: "customer" },
        { data: "route" },
        { data: "collected_by" },
        { data: "mode" },
        { data: "total_due" },
        { data: "amount" },
      ],
      columnDefs: [
        { targets: 0, width: colWidths[0] + "px" },
        { targets: 1, width: colWidths[1] + "px" },
        { targets: 2, width: colWidths[2] + "px" },
        { targets: 3, width: colWidths[3] + "px" },
        { targets: 4, width: colWidths[4] + "px" },
        { targets: 5, width: colWidths[5] + "px" },
        { targets: 6, width: colWidths[6] + "px" },
      ],
      paging: true,
      searching: false,
      ordering: false,
      info: true,
      pageLength: 50,
      lengthChange: false,
      footerCallback: function (row, data, start, end, display) {
        let total = 0;
        let totalCash = 0;
        let totalCheque = 0;
        let totalCard = 0;
        let totalBankTransfer = 0;
        let totalUPI = 0; // Assuming UPI is also a mode of payment
        data.forEach((row) => {
          const amount = parseFloat(row.amount) || 0;
          total += amount;
          const mode = row.mode?.toLowerCase();
          if (mode === "cash") {
            totalCash += amount;
          } else if (mode === "cheque") {
            totalCheque += amount;
          } else if (mode === "card" || mode === "cc") {
            totalCard += amount;
          } else if (mode === "bank transfer") {
            totalBankTransfer += amount;
          }else if (mode === "upi") {
            totalUPI += amount; // Assuming UPI is also a mode of payment
          }

        });
        const formattedTotal = total.toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
        $("#totalAmountFooter").html(formattedTotal);
        $("#totalAmount").html(formattedTotal);
        $("#totalcash").html(
          totalCash.toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        );
        $("#totalcard").html(
          totalCard.toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        );
        $("#totalcheque").html(
          totalCheque.toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        );
        $("#totalbanktransfer").html(
          totalBankTransfer.toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        );
        $("#totalupi").html(
          totalUPI.toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })  
        );

      },
    });
    const addResizerListeners = () => {
      const resizers = document.querySelectorAll('#PaymentCollection .th-resizer');
      resizers.forEach((resizer, index) => {
        const handleMouseDown = (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          startResizing(index, e);
        };
        resizer.addEventListener('mousedown', handleMouseDown);
        resizer._resizerHandler = handleMouseDown;
      });
    };
    const timeoutId = setTimeout(() => {
      addResizerListeners();
      $('#PaymentCollection thead th').each(function (idx) {
        $(this).css('width', colWidths[idx] + 'px');
      });
    }, 100);
    return () => {
      clearTimeout(timeoutId);
      const resizers = document.querySelectorAll('#PaymentCollection .th-resizer');
      resizers.forEach((resizer) => {
        if (resizer._resizerHandler) {
          resizer.removeEventListener('mousedown', resizer._resizerHandler);
        }
      });
      table.destroy();
    };
  }, [filteredData]);

  useEffect(() => {
    const styleSheet = document.createElement('style');
    styleSheet.textContent = `.th-resizer:hover { background-color: rgba(0, 0, 0, 0.3) !important; } .resizable-header { position: relative; user-select: none; }`;
    document.head.appendChild(styleSheet);
    return () => {
      if (document.head.contains(styleSheet)) {
        document.head.removeChild(styleSheet);
      }
    };
  }, []);

  const fetchCustomerNameOptions = async (inputValue) => {
    if (!inputValue || inputValue.length < 3) return;

    const formData = new FormData();
    formData.append("term", inputValue);
    formData.append("limit", "10");

    try {
      const response = await fetch(`${config.API_URL}/suggestions`, {
        method: "POST",
        headers: { authorization: `Bearer ${accessToken}` },
        body: formData,
      });

      const data = await response.json();
      if (Array.isArray(data.results)) {
        const formattedOptions = data.results.map((item) => ({
          label: item.text,
          value: item.id,
        }));
        setCustomerOptions(formattedOptions);
      }
    } catch (error) {
      console.error("Error fetching customer options:", error);
    }
  };

  const exportToExcel = () => {
    const exportData = filteredData.map((item, i) => ({
      Sr: i + 1,
      Date: item.date || "",
      Customer: item.customer || "",
      Route: item.route || "",
      "Collected By": item.collected_by || "",
      Mode: item.mode || "",
      "Total Due": parseFloat(item.total_due) || "",
      Amount: parseFloat(item.amount) || 0,
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Payments");
    XLSX.writeFile(wb, "PaymentCollection.xlsx");
  };

  const exportToPDF = async () => {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4"
    });
    const margin = 10;
    let y = 10;

    // Prepare logo
    const logoUrl = `${config.BASE_URL}/assets/img/${accessToken}_logo.png`;
    // const logoWidth = 40;
    // const logoHeight = 15;

    // Fetch logo as base64 for jsPDF
    let logoImg = logoBase64;
    if (!logoImg) {
      try {
        const response = await fetch(logoUrl);
        const blob = await response.blob();
        logoImg = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      } catch {
        logoImg = null;
      }
    }

    // Draw logo
    const logoWidth = 40;
    const logoHeight = 18;
    if (logoImg) {
      try {
        doc.addImage(logoImg, 'PNG', margin, y, logoWidth, logoHeight);
      } catch (e) { }
    }
    console.log("Shop Details:", shopDetails.shop_name);
    // Draw shop details to the right of the logo
    if (shopDetails) {
      const detailsX = margin + logoWidth + 5;
      let detailsY = y + 2;

      doc.setFontSize(13);
      doc.setFont(undefined, 'bold');
      doc.text(shopDetails.shop_name || '', detailsX, detailsY);
      detailsY += 6;

      doc.setFontSize(8);
      doc.setFont(undefined, 'normal');
      if (shopDetails.address) {
        doc.text(shopDetails.address.split(','), detailsX, detailsY);
        detailsY += 8;
      }

      let phoneEmail = [];
      if (shopDetails.phone) phoneEmail.push(`Phone No : ${shopDetails.phone}`);
      if (shopDetails.email) phoneEmail.push(`Email : ${shopDetails.email}`);
      if (phoneEmail.length > 0) {
        doc.text(phoneEmail.join(' | '), detailsX, detailsY);
        detailsY += 5;
      }
      let companyVat = [];
      if (shopDetails.company_reg_no) companyVat.push(`Company No : ${shopDetails.company_reg_no}`);
      if (shopDetails.vat_no) companyVat.push(`VAT No : ${shopDetails.vat_no}`);
      if (shopDetails.website) companyVat.push(`Website : ${shopDetails.website}`);
      if (companyVat.length > 0) {
        doc.text(companyVat.join(' | '), detailsX, detailsY);
        detailsY += 5;
      }

      // Move y below the logo/details block
      y = Math.max(y + logoHeight + 2, detailsY);
    }

    // Title
    doc.setFontSize(16);
    // doc.text("Payment Collection", margin, y);
    y += 5;

    // Date range
    let dateRangeText = "";
    if (dates && dates[0] && dates[1]) {
      dateRangeText = `Payment Collection Date : ${format(dates[0], "dd-MM -yyyy")} - ${format(dates[1], "dd-MM-yyyy")}`;
    }
    doc.setFontSize(12);
    doc.text(dateRangeText, margin, y);
    y += 6;

    // Calculate totals
    let total = 0, totalCash = 0, totalCheque = 0, totalCard = 0, totalBankTransfer = 0,totalUPI = 0;
    filteredData.forEach((row) => {
      const amount = parseFloat(row.amount) || 0;
      total += amount;
      const mode = row.mode?.toLowerCase();
      if (mode === "cash") totalCash += amount;
      else if (mode === "cheque") totalCheque += amount;
      else if (mode === "card" || mode === "cc") totalCard += amount;
      else if (mode === "bank transfer") totalBankTransfer += amount;
      else if (mode === "upi") totalUPI += amount; // Assuming UPI is also a mode of payment
    });

    // Format totals
    const formatAmt = (amt) => amt.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const totalsText = [
      `Cash: ${formatAmt(totalCash)}`,
      `Card: ${formatAmt(totalCard)}`,
      `Cheque: ${formatAmt(totalCheque)}`,
      `Bank Transfer: ${formatAmt(totalBankTransfer)}`,
      `UPI: ${formatAmt(totalUPI)}`,
      `Total Amount: ${formatAmt(total)}`
    ].join("    ");
    doc.setFontSize(10);
    doc.text(totalsText, margin, y);
    y += 5;

    // Table
    const tableColumn = [
      "Sr",
      "Date",
      "Customer",
      "Route",
      "Collected By",
      "Mode",
      "Total Due",
      "Amount",
    ];
    const tableRows = filteredData.map((item, i) => [
      i + 1,
      item.date || "",
      item.customer || "",
      item.route || "",
      item.collected_by || "",
      item.mode || "",
      parseFloat(item.total_due) || "0.00",
      parseFloat(item.amount) || 0,
    ]);
    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: y,
      styles: {
        fontSize: 8,
        lineWidth: 0.2,
        lineColor: [0, 0, 0],
        textColor: [0, 0, 0]
      },
      tableLineColor: [0, 0, 0],
      tableLineWidth: 0.2,
      theme: 'grid',
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0]
      },
      columnStyles: {
        6: { halign: 'right' }, // "Total Due"
        7: { halign: 'right' }  // "Amount"
      },
      margin: { left: 8, right: 8 }  // <== This reduces side margins
    });



    doc.save("PaymentCollection.pdf");
  };

  const handleInputChange = (inputValue) => {
    if (inputValue && inputValue.length >= 3) {
      fetchCustomerNameOptions(inputValue);
    }
  };

  const handleChange = (selectedOption) => {
    setCustomerInputValue(selectedOption);
    setCustomerFilter(selectedOption?.label || "");
  };

  const handleDateChange = (value) => {
    setDates(value);
  };

  const handleSalesrepChange = (selectedOption) => {
    setSalesrepInputValue(selectedOption);
  };

  const fetchSalesreps = async () => {
    try {
      const response = await fetch(`${config.API_URL}/getSalesRep`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({}),
      });
      const data = await response.json();
      setSalesrepOptions(
        Array.isArray(data.data)
          ? data.data.map((rep) => ({
            value: rep.id,
            label: `${rep.first_name}${rep.last_name ? " " + rep.last_name : ""
              }`.trim(),
          }))
          : []
      );
    } catch (error) {
      setSalesrepOptions([]);
      console.error("Error fetching sales reps:", error);
    }
  };

  useEffect(() => {
    fetchSalesreps();
  }, [accessToken]);

  useEffect(() => {
    let filtered = receivedPayment;
    if (customerFilter) {
      filtered = filtered.filter((item) =>
        item.customer?.toLowerCase().includes(customerFilter.toLowerCase())
      );
    }
    if (salesrepInputValue?.label) {
      filtered = filtered.filter(
        (item) =>
          item.collected_by?.toLowerCase() ===
          salesrepInputValue.label.toLowerCase()
      );
    }
    setFilteredData(filtered);
  }, [customerFilter, salesrepInputValue, receivedPayment]);

  return (
    <>
      <Header />
      <div className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <Link to="/Dashboard">
                <i className="fa fa-home"></i>
              </Link>
              <Link to="#">Account</Link>
              <Link to="#">Payments Collection</Link>
            </div>
          </div>
        </div>
      </div>

      <div className="main-container">
        <div className="container-fluid">
          <div className="backlist-content-area">
            <div className="row mb-3 align-items-end">
              <div className="col-md-2">
                <label className="form-label">
                  <b>Date</b>
                </label>
                <CommonDatePicker
                  value={dates}
                   showOneCalendar
                  // placeholder="DD/MM/YYYY - DD/MM/YYYY"
                  onChange={handleDateChange}
                  format="dd/MM/yyyy"
                  character=" - "
                  style={{ width: "100%" }}
                />
              </div>

              <div className="col-md-3">
                <label className="form-label">
                  <b>Customer</b>
                </label>
                <Select
                  isClearable
                  onInputChange={handleInputChange}
                  onChange={handleChange}
                  options={customerOptions}
                  placeholder="Search..."
                  value={customerInputValue}
                  menuPortalTarget={document.body}
                                    styles={{
                                        // Fixes the overlapping problem of the component
                                        menu: provided => ({ ...provided, zIndex: 9999 }),
                                        menuPortal: provided => ({ ...provided, zIndex: 9999 })
                                    }}
                />
              </div>

              <div className="col-md-2">
                <label className="form-label">
                  <b>Collected By</b>
                </label>
                <Select
                  isClearable
                  onChange={handleSalesrepChange}
                  options={salesrepOptions}
                  placeholder="Search..."
                  value={salesrepInputValue}
                  menuPortalTarget={document.body}
                                    styles={{
                                        // Fixes the overlapping problem of the component
                                        menu: provided => ({ ...provided, zIndex: 9999 }),
                                        menuPortal: provided => ({ ...provided, zIndex: 9999 })
                                    }}
                />
              </div>

              <div className="col-md-1 text-end">
                <button className="acceptbtn" onClick={searchFormData}>
                  Submit
                </button>
              </div>

              <div className="col-md-1 text-end">

              </div>


              <div className="col-md-3 text-end">
                <button className="acceptbtn" onClick={exportToExcel}>
                  Export Excel
                </button>
                <button className="acceptbtn" style={{ marginRight: '10px' }} onClick={exportToPDF}>
                  Export PDF
                </button>
              </div>
            </div>
            <div className="row" style={{ marginBottom: "-20px" }}>
              <div className="col-md-12">

                <label className="form-label">
                  Cash:{" "}
                  <b
                    id="totalcash"
                    style={{ marginLeft: "5px", marginRight: "10px" }}
                  ></b>
                </label>
                <span> | </span>
                <label className="form-label">
                  Card:{" "}
                  <b
                    id="totalcard"
                    style={{ marginLeft: "5px", marginRight: "10px" }}
                  ></b>
                </label>
                <span> | </span>
                <label className="form-label">
                  Cheque: <b id="totalcheque"></b>
                </label>
                <span> | </span>
                <label className="form-label">
                  Bank Transfer: <b id="totalbanktransfer"></b>
                </label>
                 <span> | </span>
                <label className="form-label">
                   UPI: <b id="totalupi"></b>
                </label>
                <span> | </span>
                <label className="form-label">
                  Total Amount: <b id="totalAmount"></b>
                </label>
              </div>
            </div>
            <div
              className="verical-scrl-wrapper autoheight-table payment-collection-list"
              id="style-3"
            >
              <table
                className="table table-bordered dataTable resizable"
                id="PaymentCollection"
                ref={tableRef}
              >
                <thead>
                  <tr>
                    {["Date", "Customer Name(A/C No)", "Route", "Collected By", "Mode", "Amount Due", "Collected Amt"].map((header, idx) => (
                      <th
                        key={header}
                        className="resizable-header"
                        style={{
                          width: colWidths[idx],
                          minWidth: 50,
                          position: "relative",
                          padding: "8px"
                        }}
                      >
                        {header}
                        {idx < colWidths.length - 1 && (
                          <div
                            className="th-resizer"
                            data-column-index={idx}
                            title="Drag to resize column"
                            style={{
                              position: 'absolute',
                              right: '-2px',
                              top: 0,
                              width: '5px',
                              height: '100%',
                              cursor: 'col-resize',
                              zIndex: 999,
                              userSelect: 'none'
                            }}
                            onMouseDown={(e) => startResizing(idx, e)}
                          />
                        )}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody></tbody>
                <tfoot>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th style={{ textAlign: "right" }}>Total:</th>
                    <th
                      style={{ textAlign: "right" }}
                      id="totalAmountFooter"
                    ></th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PaymentProcess;
